import Enumerable from "linq";

export function leftOuterJoin<TLeft, TRight, TKey, TResult>(
    left: Array<TLeft>,
    right: Array<TRight>,
    leftKeySelector: (l: TLeft) => TKey,
    rightKeySelector: (r: TRight) => TKey,
    resultSelector: (l: TLeft, r: TRight) => TResult): Enumerable.IEnumerable<TResult> {

    return Enumerable
        .from(left)
        .groupJoin(right,
            leftKeySelector,
            rightKeySelector,
            (l, r) => {
                return { left: l, right: r };
            })
        .selectMany(l => l.right.defaultIfEmpty(), (l, r) => resultSelector(l.left, r));
}

export function rightOuterJoin<TLeft, TRight, TKey, TResult>(
    left: Array<TLeft>,
    right: Array<TRight>,
    leftKeySelector: (l: TLeft) => TKey,
    rightKeySelector: (r: TRight) => TKey,
    resultSelector: (l: TLeft, r: TRight) => TResult): Enumerable.IEnumerable<TResult> {

    return leftOuterJoin(
        right,
        left,
        rightKeySelector,
        leftKeySelector,
        (r, l) => resultSelector(l, r)
    );
}

export function fullOuterJoin<TLeft, TRight, TKey, TResult>(
    left: Array<TLeft>,
    right: Array<TRight>,
    leftKeySelector: (l: TLeft) => TKey,
    rightKeySelector: (r: TRight) => TKey,
    resultSelector: (l: TLeft, r: TRight) => TResult): Enumerable.IEnumerable<TResult> {

    const leftJoin = leftOuterJoin(
        left,
        right,
        leftKeySelector,
        rightKeySelector,
        (l, r) => {
            return { l, r };
        }
    );

    const rightJoin = rightOuterJoin(
        left,
        right,
        leftKeySelector,
        rightKeySelector,
        (l, r) => {
            return { l, r };
        }
    );

    const outerJoin = leftJoin.union(
        rightJoin,
        lr => `${lr.l ? leftKeySelector(lr.l) : undefined}:${lr.r ? rightKeySelector(lr.r) : undefined}`
    );

    return outerJoin.select(a => resultSelector(a.l, a.r));
}

